import "../scss/app.scss";

const searchToggle = document.getElementById("search-toggle");

if (searchToggle && searchToggle.parentElement) {
  searchToggle.addEventListener("click", (e) => {
    e.preventDefault();

    const searchInput = searchToggle.parentElement.querySelector("input");

    if (!searchInput) {
      return;
    }

    searchInput.classList.toggle("active");
    searchInput.focus();
    searchToggle.style.display = "none";
  });
}
